// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IntakePatientIntakeDefaultResponseData {
    static getAttributeTypeMap() {
        return IntakePatientIntakeDefaultResponseData.attributeTypeMap;
    }
}
IntakePatientIntakeDefaultResponseData.discriminator = undefined;
IntakePatientIntakeDefaultResponseData.additionalProperties = false;
IntakePatientIntakeDefaultResponseData.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "accountDisplayId",
        "baseName": "accountDisplayId",
        "type": "string"
    },
    {
        "name": "intakeCaseId",
        "baseName": "intakeCaseId",
        "type": "number"
    },
    {
        "name": "workflowIds",
        "baseName": "workflowIds",
        "type": "Array<number>"
    },
];
//# sourceMappingURL=intakePatientIntakeDefaultResponseData.js.map